import type { UseQueryResult } from '@tanstack/react-query';
import { useApiProblem } from '@/shared/api';
import { SurfaceLoadError } from '@/shared/components';
import { parkingAccessDenied, parkingProblemText } from './parkingProblemText';

/**
 * Die Stellplatzliste ist nicht geladen – nie als „keine Parkplätze“ getarnt: offline „Keine
 * Verbindung“, sonst der Grund mit Code; fehlt das Recht am Objekt, kein „Erneut laden“.
 */
export function ParkingListLoadError({
  query,
  fallback,
}: {
  query: Pick<UseQueryResult<unknown>, 'error' | 'fetchStatus' | 'isFetching' | 'refetch'>;
  fallback: string;
}) {
  const problem = useApiProblem(query.error ?? null);
  return (
    <SurfaceLoadError
      message={
        query.fetchStatus === 'paused'
          ? 'Keine Verbindung – die Parkplätze sind nicht geladen.'
          : parkingProblemText(problem, fallback)
      }
      onRetry={parkingAccessDenied(problem) ? undefined : () => void query.refetch()}
      retrying={query.isFetching}
    />
  );
}
